<template>
    <div class="page-adder-block">
      Toevoegen: 
      <span>
        <span class="edited_content" v-if="!editmode">
          <button class="edit_icon edit_icon_menu add-block-button" @click.prevent="editmode = true">Tekst (met evt foto)</button>
        </span>
        <div class="edit_field" v-if="editmode">
          <form id="edit_pagetext" method="post" @submit.prevent="createPage('normal', pagetitle)">
            <input class="textinput" type="text" v-model="pagetitle" name="field_subpagetitle" placeholder="Vul paginanaam in...">
            <input type="submit" name="submit_subpagetitle" value="Toevoegen" class="btn btn-primary">
          </form>
        </div>
      </span>

      <span>
        <span class="edited_content" v-if="!editmode">
          <button class="edit_icon edit_icon_menu add-block-button" @click.prevent="createPage('logos', 'Wij werken met')">Logobalk</button>
        </span>
      </span>

      <span>
        <span class="edited_content" v-if="!editmode">
          <button class="edit_icon edit_icon_menu add-block-button" @click.prevent="createPage('reviews', 'Wat klanten zeggen')">Referenties</button>
        </span>
      </span>

      <span>
        <span class="edited_content" v-if="!editmode">
          <button class="edit_icon edit_icon_menu add-block-button" @click.prevent="createPage('quote', 'Een quote')">Quote</button>
        </span>
      </span>

      <span>
        <span class="edited_content" v-if="!editmodecols">
          <button class="edit_icon edit_icon_menu add-block-button" @click.prevent="editmodecols = true">Tekst in kolommen</button>
        </span>
        <div class="edit_field" v-if="editmodecols">
          <form id="edit_pagetext" method="post" @submit.prevent="createPage('columns', pagetitle)">
            <input class="textinput" type="text" v-model="pagetitle" name="field_subpagetitle" placeholder="Vul paginanaam in...">
            <input type="submit" name="submit_subpagetitle" value="Toevoegen" class="btn btn-primary">
          </form>
        </div>
      </span>

      <span>
        <span class="edited_content" v-if="!editmodecards">
          <button class="edit_icon edit_icon_menu add-block-button" @click.prevent="editmodecards = true">Klikbare cards</button>
        </span>
        <div class="edit_field" v-if="editmodecards">
          <form id="edit_pagetext" method="post" @submit.prevent="createPage('cards', pagetitle)">
            <input class="textinput" type="text" v-model="pagetitle" name="field_subpagetitle" placeholder="Vul paginanaam in...">
            <input type="submit" name="submit_subpagetitle" value="Toevoegen" class="btn btn-primary">
          </form>
        </div>
      </span>

      <span>
        <span class="edited_content" v-if="!editmode">
          <button class="edit_icon edit_icon_menu add-block-button" @click.prevent="createPage('Contactform', 'Contact', 'form')">Contactform</button>
        </span>
      </span>

      <span v-for="(feature, index) in content.features">
        <span class="edited_content" v-if="editmodecustom != index">
          <button class="edit_icon edit_icon_menu add-block-button" @click.prevent="editmodecustom = index">{{feature.name}}</button>
        </span>
        <div class="edit_field" v-if="editmodecustom == index">
          <form id="edit_pagetext" method="post" @submit.prevent="createPage(feature.name, pagetitle, feature.type)">
            <input class="textinput" type="text" v-model="pagetitle" name="field_subpagetitle" placeholder="Vul paginanaam in...">
            <input type="submit" name="submit_subpagetitle" value="Toevoegen" class="btn btn-primary">
          </form>
        </div>
      </span>

    </div>
</template>

<script>  

import { userService } from '../../services/user.service.js';
import { authHeader } from '../../services/auth-header.js';

import axios from 'axios';

export default {
  props:{
    parentpageid: String,
    content: Object,
    websiteid: String
  },
  data: function(){
    return{
      editmode: false,
      editmodecols: false,
      editmodecards: false,
      editmodecustom: -1,
      pagetitle: ''
    }
  },
  methods: {
    createPage(style, name, type){

        const requestOptions = {
          headers: authHeader()
        }

        const pageid = ''

        if(this.parentpageid == 'home'){
          //get pageid first
          this.pageid = 'home'
        } else {
          this.pageid = this.parentpageid
        }

        const data = {
          websiteid: this.websiteid,
          belongsto: this.pageid,
          pagetitle: name,
          blockstyle: style,
          blocktype: type
        }

        axios.post(process.env.VUE_APP_ROOT_API+'/pages/', data, requestOptions)
        .then(response => {
            this.pagetitle = ''
            this.editmode = false,
            this.editmodecols = false,
            this.editmodecards = false,
            this.$emit('clicked')
        })
        
    }
  }
}
</script>